import { Directive, HostBinding, Input } from '@angular/core';

type ButtonType = 'warning' | 'primary' | 'danger' | 'secondary' | 'success' | 'info' | 'light' | 'dark' | 'link' | 'outline-primary';

@Directive({
  selector: '[appButton]',
  standalone: true,
})
export class ButtonDirective {
  @Input('appButton') type: ButtonType = 'primary';

  @HostBinding('class')
  get classes(): string {
    return `btn btn-${this.type}`;
  }
}
